import { render } from "./person.vue?vue&type=template&id=4afd44ec"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"

import "./person.vue?vue&type=style&index=0&id=4afd44ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__